"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHInputProviderMouse = exports.MouseBindableInput = exports.MouseAxis = exports.MouseInput = void 0;
const KHInputAxis_1 = require("./KHInputAxis");
const KHInputKey_1 = require("./KHInputKey");
const KHInputProvider_1 = require("./KHInputProvider");
const KHUnifiedInput_1 = require("./KHUnifiedInput");
var MouseInput;
(function (MouseInput) {
    MouseInput[MouseInput["Left"] = 0] = "Left";
    MouseInput[MouseInput["Right"] = 1] = "Right";
    MouseInput[MouseInput["ScrollUp"] = 2] = "ScrollUp";
    MouseInput[MouseInput["ScrollDown"] = 3] = "ScrollDown";
})(MouseInput = exports.MouseInput || (exports.MouseInput = {}));
var MouseAxis;
(function (MouseAxis) {
    MouseAxis[MouseAxis["X"] = 0] = "X";
    MouseAxis[MouseAxis["Y"] = 1] = "Y";
    MouseAxis[MouseAxis["ScrollUp"] = 2] = "ScrollUp";
    MouseAxis[MouseAxis["ScrollDown"] = 3] = "ScrollDown";
})(MouseAxis = exports.MouseAxis || (exports.MouseAxis = {}));
var MouseBindableInput;
(function (MouseBindableInput) {
    MouseBindableInput[MouseBindableInput["LMB"] = 0] = "LMB";
    MouseBindableInput[MouseBindableInput["LMBTap"] = 1] = "LMBTap";
    MouseBindableInput[MouseBindableInput["LMBHold"] = 2] = "LMBHold";
    MouseBindableInput[MouseBindableInput["RMB"] = 3] = "RMB";
    MouseBindableInput[MouseBindableInput["RMBTap"] = 4] = "RMBTap";
    MouseBindableInput[MouseBindableInput["RMBHold"] = 5] = "RMBHold";
    MouseBindableInput[MouseBindableInput["ScrollUp"] = 6] = "ScrollUp";
    MouseBindableInput[MouseBindableInput["ScrollDown"] = 7] = "ScrollDown";
})(MouseBindableInput = exports.MouseBindableInput || (exports.MouseBindableInput = {}));
class KHInputProviderMouse extends KHInputProvider_1.KHInputProvider {
    constructor(scene) {
        super();
        this.scene = scene;
        this.input = new Map();
        this.input.set(MouseInput.Left, new KHInputKey_1.KHInputKey());
        this.input.set(MouseInput.Right, new KHInputKey_1.KHInputKey());
        this.input.set(MouseInput.ScrollUp, new KHInputKey_1.KHInputKey());
        this.input.set(MouseInput.ScrollDown, new KHInputKey_1.KHInputKey());
        this.inputCallbackState = new Map();
        this.inputCallbackState.set(MouseInput.Left, false);
        this.inputCallbackState.set(MouseInput.Right, false);
        this.inputCallbackState.set(MouseInput.ScrollUp, false);
        this.inputCallbackState.set(MouseInput.ScrollDown, false);
        this.axis = new Map();
        this.axis.set(MouseAxis.X, new KHInputAxis_1.KHInputAxis());
        this.axis.set(MouseAxis.Y, new KHInputAxis_1.KHInputAxis());
        this.axis.set(MouseAxis.ScrollUp, new KHInputAxis_1.KHInputAxis());
        this.axis.set(MouseAxis.ScrollDown, new KHInputAxis_1.KHInputAxis());
        this.axisCallbackState = new Map();
        this.axisCallbackState.set(MouseAxis.X, 0);
        this.axisCallbackState.set(MouseAxis.Y, 0);
        this.axisCallbackState.set(MouseAxis.ScrollUp, 0);
        this.axisCallbackState.set(MouseAxis.ScrollDown, 0);
        this.scene.input.on('wheel', (pointer, currentlyOver, dx, dy, dz, event) => {
            if (pointer.deltaY < 0) {
                this.inputCallbackState.set(MouseInput.ScrollUp, true);
                this.axisCallbackState.set(MouseAxis.ScrollUp, -pointer.deltaY);
            }
            else if (pointer.deltaY > 0) {
                this.inputCallbackState.set(MouseInput.ScrollDown, true);
                this.axisCallbackState.set(MouseAxis.ScrollDown, pointer.deltaY);
            }
        });
        this.scene.input.on('pointermove', (pointer) => {
            this.axisCallbackState.set(MouseAxis.X, pointer.x);
            this.axisCallbackState.set(MouseAxis.Y, pointer.y);
        });
    }
    update(now, delta) {
        const pointer = this.scene.input.activePointer;
        this.inputCallbackState.set(MouseInput.Left, pointer.leftButtonDown());
        this.inputCallbackState.set(MouseInput.Right, pointer.rightButtonDown());
        this.input.forEach((_value, key) => {
            this._updateInput(key, this.inputCallbackState.get(key));
        });
        this.axis.forEach((_value, key) => {
            this._updateAxis(key, this.axisCallbackState.get(key));
        });
        this.inputCallbackState.forEach((_value, key) => {
            this.inputCallbackState.set(key, false);
        });
        // We have to clear these manually as X and Y axes should not be reset.
        this.axisCallbackState.set(MouseAxis.ScrollUp, 0);
        this.axisCallbackState.set(MouseAxis.ScrollDown, 0);
    }
    _updateInput(input, value) {
        this.input.get(input).update(value);
        if (value) {
            KHUnifiedInput_1.KHUnifiedInput.lastInputSource = this;
        }
    }
    _updateAxis(axis, value) {
        if (this.axis.get(axis).update(value)) {
            KHUnifiedInput_1.KHUnifiedInput.lastInputSource = this;
        }
    }
    getInput(input) {
        return this.input.get(input);
    }
    getAxis(axis) {
        return this.axis.get(axis);
    }
    type() {
        return KHInputProviderMouse.INPUT_TYPE;
    }
}
exports.KHInputProviderMouse = KHInputProviderMouse;
KHInputProviderMouse.INPUT_TYPE = "mouse";
